import { useQuery } from '@tanstack/react-query';
import { getControlsInit } from '@api/controls';
import { trackQueryError } from '@src/utils/sensor/apptracker';
import { useControlsStore } from '@src/globalStore/controlsStore';

const useControlsInit = ({ enabled = true } = {}) => {
  const { setAll } = useControlsStore();

  // Fetch controls init data and update store
  const { isError, isFetched } = useQuery(
    ['controls-init'],
    async () => {
      const data = await getControlsInit();
      if (data) {
        setAll(data);
        return data;
      }
      return null;
    },
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled,
      staleTime: 10 * 60 * 1000, // 10 minutes
      keepPreviousData: true,
      refetchInterval: 5 * 60 * 1000, // 5 minutes
      notifyOnChangeProps: ['isError', 'isFetched'],
      onError: (err) => {
        trackQueryError({ type: 'controls-init', err });
      },
    },
  );

  return { isError, isFetched };
};

export default useControlsInit;
